import SearchIcon from 'common/components/svg-icon/search';
import styles from './styles.less';
import { action, extendObservable } from 'mobx';
import { observer } from 'mobx-react';
import { debounce, uniqueId } from 'lodash';


@observer
class ClipSearchForm extends React.Component {
    static propTypes = {
        onClear: React.PropTypes.func.isRequired,
        onSearch: React.PropTypes.func.isRequired,
        query: React.PropTypes.string,
        title: React.PropTypes.string.isRequired
    };

    static defaultProps = {
        query: '',
        title: 'Search Clips'
    };

    constructor(props) {
        super(props);
        extendObservable(this, {
            id: uniqueId('ClipSearchForm'),
            value: props.query || ''
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.query !== this.props.query) {
            this.setValue(nextProps.query);
        }
    }

    componentWillUnmount() {
        this.handleKeyDown.cancel();
    }

    render() {
        return (
            <form
                autoComplete='off'
                className={ cx(styles.root, this.props.className) }
                onSubmit={ this.handleSubmit }>
                <header className={ styles.header }>
                    <label
                        className={ styles.title }
                        htmlFor={ `${this.id}_input` }>
                        { this.props.title }
                    </label>
                </header>
                <div className={ styles.content }>
                    <input
                        className={ styles.input }
                        id={ `${this.id}_input` }
                        name={ `${this.id}_input` }
                        onKeyDown={ this.handleKeyDown }
                        onChange={ this.handleValueChange }
                        ref='input'
                        type='text'
                        value={ this.value }
                    />
                    <button
                        className={ styles.submit }
                        disabled={ !this.value.trim() }
                        type='submit'>
                        <SearchIcon className={ styles.searchIcon } />
                    </button>
                </div>
            </form>
        );
    }

    handleKeyDown = debounce(() => {
        if (this.value.length >= 3) {
            this.search();
        }
        if (this.value.length === 0) {
            this.props.onClear();
        }
    }, 300, { leading: false, trailing: true });

    handleSubmit = (e) => {
        e.preventDefault();
        this.search();
    };

    handleValueChange = (e) => {
        e.preventDefault();
        this.setValue(e.target.value);
    };

    search() {
        const value = this.value.trim();
        if (value) {
            this.handleKeyDown.cancel();
            this.props.onSearch(value);
        }
    }

    @action setValue = (value) => {
        this.value = value.substring(0, 40);
    };
}


export default ClipSearchForm;



// WEBPACK FOOTER //
// ./src/show-page/components/clip-search-form/index.js